import dashboardCommitTypes from './commit-types';
import ReducerUtilities from '../../../shared/store/reducer-utilities';

const INITIAL_DASHBOARD_STATE = {
  isLoading: [],
  dor: null,
  wor: null,
  activeFtos: null,
  activeOits: null,
  oitsRemedials: null,
  outstandingForms: null,
  assignedOits: null,
  trainingProgramsStatsTotalWeeks: null,
  riskAlerts: null,
};

function dashboardReducers(state = INITIAL_DASHBOARD_STATE, action) {
  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case dashboardCommitTypes.SET_DASHBOARD_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };

    case dashboardCommitTypes.SET_DOR_STATS:
      return {
        ...state,
        dor: action.dor.count,
      };

    case dashboardCommitTypes.SET_WOR_STATS:
      return {
        ...state,
        wor: action.wor.count,
      };

    case dashboardCommitTypes.SET_FTO_STATS_ACTIVE:
      return {
        ...state,
        activeFtos: action.activeFtos.count,
      };

    case dashboardCommitTypes.SET_OIT_STATS_ACTIVE:
      return {
        ...state,
        activeOits: action.activeOits.count,
      };

    case dashboardCommitTypes.SET_OIT_STATS_REMEDIAL:
      return {
        ...state,
        oitsRemedials: action.oitsRemedials.count,
      };

    case dashboardCommitTypes.SET_OUTSTANDING_FORMS:
      return {
        ...state,
        outstandingForms: action.outstandingForms,
      };

    case dashboardCommitTypes.SET_ASSIGNED_OITS:
      return {
        ...state,
        assignedOits: action.assignedOits.count,
      };

    case dashboardCommitTypes.SET_TRAINING_PROGRAMS_STATS_TOTAL_WEEKS:
      return {
        ...state,
        trainingProgramsStatsTotalWeeks: action.totalWeeks,
      };

    case dashboardCommitTypes.SET_RISK_ALERTS_STATS:
      return {
        ...state,
        riskAlerts: action.riskAlerts.count,
      };

    default:
      return state;
  }
}

export default dashboardReducers;
